import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';

export interface Place {
  description: string;
  id: string;
  place_id?: string;
}

export interface PlacesResponse {
  predictions: Place[];
}

@Service()
export class PlacesService {
  http = inject(HttpClient);

  searchPlaces = (input: string) =>
    this.http.get<PlacesResponse>('agora-api/places', { params: { input } });
}
